import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// Modulos de ng-bootstrap usados por wrappers pesados y por UiModule.
import {
  NgbModule,
  NgbAccordionModule,
  NgbCollapseModule,
  NgbDropdownModule,
  NgbModalModule,
  NgbNavModule,
  NgbTooltipModule,
} from '@ng-bootstrap/ng-bootstrap';

// Otros modulos de uso transversal.
import { NgxPaginationModule } from 'ngx-pagination';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxMaskDirective, NgxMaskPipe } from 'ngx-mask';

/**
 * SharedComponentsModule
 * ----------------------------------------------------------------
 * Modulo de re-exportacion de dependencias terceras de uso transversal.
 * Tanto UiModule como UiHeavyModule lo importan, y desde ambos se
 * pueden usar pipes y directivas como `paginate`, `ngbAccordion`,
 * `ng-select`, etc. sin reimportar.
 *
 * Que NO va aqui:
 *   - Componentes propios de AVATAR (FiltrocampoComponent,
 *     AdvancedtableComponent, etc.). Esos componentes tienen muchas
 *     dependencias internas y mantenerlos en UiModule es lo seguro.
 *     Si se quisieran exponer al UiHeavyModule en el futuro, habria
 *     que convertirlos a standalone components (Angular 14.1+).
 *
 * Forma de crecerlo:
 *   Si algun wrapper pesado necesita un modulo tercero que aun no
 *   este aqui, agregarlo a imports[] y exports[] simultaneamente.
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    NgbAccordionModule,
    NgbCollapseModule,
    NgbDropdownModule,
    NgbModalModule,
    NgbNavModule,
    NgbTooltipModule,
    NgxPaginationModule,
    NgSelectModule,
    NgxMaskDirective,
    NgxMaskPipe,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    NgbAccordionModule,
    NgbCollapseModule,
    NgbDropdownModule,
    NgbModalModule,
    NgbNavModule,
    NgbTooltipModule,
    NgxPaginationModule,
    NgSelectModule,
    NgxMaskDirective,
    NgxMaskPipe,
  ]
})
export class SharedComponentsModule { }
